import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { UseCase } from '@/domain/core/UseCase'
import { UserChart } from '@/domain/models/UserChart'
import { Result } from '@/domain/protocols/Result'

import type { IUserChartRepository } from '@/data/UserChartRepository/IUserChartRepository'

export class DeleteUserChartUseCase implements UseCase<UserChart, Promise<Result<void>>> {
  private repository: IUserChartRepository

  constructor(repository?: IUserChartRepository) {
    if (repository) {
      this.repository = repository
      return
    }
    const container = InversionContainer.getInstance().getContainer()
    this.repository = container.get<IUserChartRepository>(InjectionTokens.UserChartRepository)
  }

  async execute(chart: UserChart): Promise<Result<void>> {
    try {
      return await this.repository.deleteChart(chart)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
